module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-27.694802a5.png";